import React from "react";
import Header from './Header';
import Slider from './Slider';
import Main from './Main';
import axios from 'axios';
import { _showOverlay, _hideOverlay, _getSiteLanguage} from './Constant';
import PageNotFound from './PageNotFound';
import { _getContent ,_getLanguage} from "../api/Api";
let language = "";
class Villa extends React.Component {
  constructor(props) {

    super(props);
    //let query = new URLSearchParams(props.location.search)
    let location = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    let page = window.location.href.split('/')[window.location.href.split('/').length-2];
  
    this.state = {
      page:(page == 'villa')?'main':page,
      villa: location,
      data: {},
      loading: true,
      selected_flag: 'en',
      section:(typeof this.props.location != "undefined" && typeof this.props.location.state != "undefined" && typeof this.props.location.state.section != "undefined" ?this.props.location.state.section:'' )
      
    }
   
  }

  async componentDidMount() {
    if(window.sessionStorage){
      let loca_lang=window.sessionStorage.getItem('language');
      if(typeof loca_lang !== "undefined" && loca_lang != null){
        
      }else{
        window.sessionStorage.setItem('language','en');
      }
 
    }
    let languages = await _getLanguage(this.state.villa);
    //console.log(languages);
     language = await _getSiteLanguage(languages);
    this._getContent(language);
    

  }

  _handleLanguageChange = async(language) => {
    if(window.sessionStorage){
      window.sessionStorage.setItem('language',language);
    }
       _showOverlay();
       await this._getContent(language);
       _hideOverlay();
       
  }

  _getContent=async(language)=>{
    let res = await _getContent(this.state.villa, language,this.state.page);
   // console.log(res);
    if (res.data.response === "success") {
      //console.log(res.data);
        this.setState({
        data: res.data,
        loading: false
      });
    } else {
      this.setState({
        loading: false
      });
    }
   // return;
  }

  render() {
    if (this.state.loading === true) {
      return (
        <React.Fragment>
          {_showOverlay()}
        </React.Fragment>
      );
    } else {

      if (Object.keys(this.state.data).length === 0) {
        return (
          <React.Fragment>
            {_hideOverlay()}
            <PageNotFound />
          </React.Fragment>
        )

      } else {
        return (
          <React.Fragment>
            {_hideOverlay()}
            <Header data={this.state.data} handleLanguageChange={this._handleLanguageChange}  villa= {this.state.villa}/>
            <Slider data={this.state.data} />
            <Main  section={this.state.section} data={this.state.data} page={this.state.page}/>
          </React.Fragment>
        )
      }
    }

  }
}

export default Villa;
